module.exports = __webpack_public_path__ + "media/images/ui-icons_777777_256x240-73a1fd05.png";